import { alpha, lighten, Theme } from '@mui/material';
import { useBlendColors } from 'hooks/useDesign';

export default {
    container: {
        overflow: 'auto',
        flexGrow: 1,
        position: 'relative',
    },
    bgHolder: {
        color: 'primary.main',
        position: 'absolute',
        inset: '0 0 0 0',
        overflow: 'hidden',
        svg: {
            position: 'absolute',
            top: '-46px',
            right: '-61px',
        },
    },
    content: {
        position: 'relative',
        height: 1,
        p: 3,
    },
    intro: {
        flexGrow: 1,
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
    },
    introIcon: {},
    welcomeIcon: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '8px',
        background: (theme: Theme) =>
            `linear-gradient(180deg, ${alpha(lighten(theme.palette.primary.main, 0.25), 0.8)} 0%, ${alpha(
                theme.palette.primary.main,
                0.8,
            )} 100%)`,
        boxShadow: (theme: Theme) => `0px 2px 8px 0px ${alpha(theme.palette.text.primary, 0.2)}`,
    },
    welcomeIconSvg: {
        fontSize: '32px',
        color: (theme: Theme) => theme.palette.text.opposite,
    },
    introTitle: {
        mt: 1.5,
        color: (theme: Theme) => theme.palette.primary.main,
        fontWeight: 600,
        fontSize: '16px',
    },
    introDesc: {
        mt: 0.5,
        fontSize: '14px',
    },
    examples: {
        flexShrink: 0,
    },
    examplesTitle: {
        fontWeight: 500,
        mb: 1,
    },
    examplesList: {
        marginBottom: '12px',
    },
    examplesItem: {
        backgroundColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.04)),
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.24)),
        py: 1,
        pr: 1,
        pl: 1.5,
        borderRadius: '4px',
        color: (theme: Theme) => theme.palette.primary.main,
        alignItems: 'center',
        '&:hover': {
            cursor: 'pointer',
            borderColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.6)),
            backgroundColor: (theme: Theme) => useBlendColors(alpha(theme.palette.primary.main, 0.08)),
        },
    },
    examplesItemIcon: {
        ml: 1,
        flexShrink: 0,
        display: 'inline-flex',
    },
};
